<template>
  <generic-container :title="$t('course detail')" icon="book">
    <div class="ui icon warning message" v-if="!selected">
      <i class="book icon"></i>
      <div class="content">
        <div class="header">
          {{ $t("no course is selected") }}
        </div>
        <p>{{ $t("choose one from the list on the left") }}</p>
      </div>
    </div>
    <div
      class="ui bottom attached tab segment"
      v-bind:class="{ active: selected == course }"
      v-for="(course, cidx) in courses"
      :key="cidx"
      :data-tab="'t_' + course.course.uuid"
    >
      <!-- <h4 class="ui header">{{ $t("sections") }}</h4> -->
      <div class="ui top attached tabular menu" ref="tabs">
        <a
          class="item"
          :data-tab="'t_' + section.uuid"
          v-for="(section, sidx) in course.sections"
          :key="sidx"
        >
          <div class="ui header">
            <div class="content">
              {{ section.pfs_professor.setup.name }}
              <div class="sub header">{{ section.name }}</div>
            </div>
          </div>
        </a>
      </div>
      <div
        class="ui bottom attached tab segment"
        :data-tab="'t_' + section.uuid"
        v-for="(section, sidx) in course.sections"
        :key="sidx"
      >
        <table class="ui celled table" ref="table">
          <thead>
            <tr>
              <th>{{ $t("section name") }}</th>
              <th>{{ $t("branch") }}</th>
              <th>{{ $t("studying time") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ section.name }}</td>
              <td>{{ section.std_branch.name }}</td>
              <td>{{ section.std_studying_time.name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </generic-container>
</template>

<script>
import { enterprise_setup } from "@/utils";
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "CourseAssignationDistributionRevisionCourseBasedPicker",
  components: { GenericContainer },
  props: { courses: Array },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return { courseFilter: "", selected: undefined };
  },
  methods: {
    select_course(course) {
      let vm = this;
      vm.selected = course;
      setTimeout(() => {
        window
          .jQuery(vm.$refs.tabs)
          .find(".item")
          .tab();
      }, 500);
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();
  },
};
</script>
